import { useState } from 'react'
import { COLORS, TYPE } from './tokens'
import SectionLabel from './SectionLabel'

const SUCCESS = '#2D7A4A'
const DANGER = '#C04A3D'
const DELIVERY_TARGET = 'exec_report_s09'
const JUSTIFICATION_FLOOR = 80

export default function VerifyDeliverPanel({
  review, allDispositioned, verifying, delivering, error, onVerify, onDeliver
}) {
  const [justification, setJustification] = useState('')

  const state = review?.review_state || 'draft'
  const isDraft = state === 'draft'
  const isVerified = state === 'verified'
  const isDelivered = state === 'delivered'

  const overallConfidence = review?.review_confidence?.overallConfidence
  const needsJustification = typeof overallConfidence === 'number' && overallConfidence < JUSTIFICATION_FLOOR
  const canVerify = allDispositioned && (!needsJustification || justification.trim().length > 0)

  return (
    <div style={{ paddingBottom: '32px', borderBottom: `1px solid ${COLORS.hairline}` }}>
      <SectionLabel>Sign off</SectionLabel>
      {isDelivered && (
        <div style={{ ...TYPE.body, color: SUCCESS, marginBottom: '8px' }}>
          ✓ Delivered {review.delivered_at ? new Date(review.delivered_at).toLocaleDateString() : ''}
        </div>
      )}
      {isVerified && (
        <>
          <div style={{ ...TYPE.body, color: SUCCESS, marginBottom: '12px' }}>
            ✓ Verified {review.verified_at ? new Date(review.verified_at).toLocaleDateString() : ''}
          </div>
          <p style={{ ...TYPE.supporting, color: COLORS.mutedText, marginBottom: '8px' }}>
            Deliver to Executive Report
          </p>
          <button
            onClick={() => onDeliver?.(DELIVERY_TARGET)}
            disabled={delivering}
            style={{
              ...TYPE.body, width: '100%', padding: '10px 16px',
              background: COLORS.accent, color: COLORS.retentionBg,
              border: 'none', borderRadius: '4px', cursor: delivering ? 'wait' : 'pointer'
            }}
          >
            {delivering ? 'Delivering…' : 'Mark delivered'}
          </button>
        </>
      )}
      {isDraft && (
        <>
          <p style={{ ...TYPE.supporting, color: COLORS.mutedText, marginBottom: '12px' }}>
            {allDispositioned
              ? 'All flagged findings have been reviewed. You may verify and sign off.'
              : 'Review each flagged finding before verifying.'}
          </p>
          {needsJustification && (
            <div style={{ marginBottom: '12px' }}>
              <label style={{ ...TYPE.smallCaps, color: COLORS.mutedText, display: 'block', marginBottom: '6px' }}>
                Justification (required · confidence below 80)
              </label>
              <textarea
                value={justification}
                onChange={(e) => setJustification(e.target.value)}
                rows={3}
                style={{
                  ...TYPE.supporting, width: '100%', boxSizing: 'border-box',
                  padding: '8px 10px', border: `1px solid ${COLORS.hairline}`,
                  borderRadius: '4px', color: COLORS.bodyText, background: COLORS.panelBg,
                  resize: 'vertical'
                }}
                placeholder="Explain why this review is being signed off despite lower confidence."
              />
            </div>
          )}
          <button
            onClick={() => onVerify?.(justification.trim())}
            disabled={!canVerify || verifying}
            style={{
              ...TYPE.body, width: '100%', padding: '10px 16px',
              background: canVerify ? COLORS.accent : COLORS.hairline,
              color: canVerify ? COLORS.retentionBg : COLORS.mutedText,
              border: 'none', borderRadius: '4px',
              cursor: canVerify && !verifying ? 'pointer' : 'not-allowed'
            }}
          >
            {verifying ? 'Verifying…' : 'Verify and sign off'}
          </button>
        </>
      )}
      {error && (
        <p style={{ ...TYPE.supporting, color: DANGER, marginTop: '8px' }}>{error}</p>
      )}
    </div>
  )
}
